import { useEffect, useState } from "react";
import Header from "./components/common/header";
import Footer from "./components/common/footer";

/**
 * Иконки сигналов — 1:1 с backend
 */
const EVENT_ICONS = {
  NEW_CONTRACT_DEPLOY: "🧬",

  VALUE_TX: "💰",
  LARGE_VALUE_TX: "🔴",

  ERC20_TRANSFER: "🟢",
  APPROVE: "🟡",
  CONTEXT_APPROVE: "🔵",
  FIRST_TOKEN_ACTIVITY: "🚩",

  CONTRACT_CALL: "🧩",
  CONTRACT_INTERACTION: "🔗",
  FUNCTION: "🧩",

  BOT_LIKE_TX: "🤖",
  COMPLEX_TX: "🧠",

  REAL_SWAP: "🔥",
  SWAP_DIRECTION: "🟣",
  SWAP_AMOUNT: "💸",

  GAS_SPIKE: "⛽",
  ZERO_VALUE_LOGIC_CALL: "⚙️",

  OTHER_TX: "📦"
};

export default function SignalsPage() {
  const [signals, setSignals] = useState([]);

  /**
   * WebSocket — только приём данных
   */
  useEffect(() => {
    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        setSignals((prev) => [...prev, msg].slice(-300));
      } catch {
        setSignals((prev) => [...prev, e.data].slice(-300));
      }
    };

    return () => ws.close();
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#000"
      }}
    >
      {/* ===== HEADER ===== */}
      <Header />

      {/* ===== CONTENT ===== */}
      <div
        style={{
          flex: 1,
          padding: "20px",
          color: "#0f0",
          fontFamily: "monospace",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <h2 style={{ marginBottom: "12px" }}>
          Mempool Signals
        </h2>

        {/* ===== SIGNALS CONTAINER ===== */}
        <div
          style={{
            flex: 1,
            border: "1px solid #222",
            borderRadius: 6,
            padding: "10px",
            overflowY: "auto",
            overflowAnchor: "none", // КРИТИЧНО
            fontSize: "13px",
            background: "#000"
          }}
        >
          {signals.map((line, i) => {
            if (typeof line === "string") {
              return (
                <div key={i} style={{ color: "#666" }}>
                  {line}
                </div>
              );
            }

            const icon = EVENT_ICONS[line.event] || "📦";

            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginBottom: 4,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word"
                }}
              >
                <span style={{ width: 22 }}>
                  {icon}
                </span>

                <span style={{ marginRight: 6 }}>
                  {line.event}
                </span>

                <span style={{ color: "#777" }}>
                  {JSON.stringify(line.payload)}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <Footer />
    </div>
  );
}